module.exports = __webpack_public_path__ + "static/media/ICT-7.222d7573.png";